import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Avatar,
  Box,
  Button,
  Center,
  Checkbox,
  Flex,
  HStack,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  Tab,
  Table,
  TableContainer,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { BsCheckLg, BsChevronDown } from "react-icons/bs";

import { RiSearch2Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import AdminDashboardHeader from "../../components/admin/AdminHeader";
import AdminSidebar from "../../components/admin/AdminSidebar";
import Loading from "../../components/common/Loading";

import { FaTimes } from "react-icons/fa";
import { ApproveRejectDeferModal } from "../../components/admin/defer/ApproveRejectDeferModal";
import { IDefferedRequests } from "../../models/admin/deferred.model";
import DefermentService from "../../services/admin/deferment.service";
import { getFullDate } from "../../utils/classOfDegree";

const AdminDeferredAdmission = () => {
  const navigate = useNavigate();
  const [newRequests, setNewRequests] = useState<IDefferedRequests[]>([]);
  const [rejectedRequests, setRejectedRequests] = useState<IDefferedRequests[]>(
    []
  );
  const [approvedRequests, setApprovedRequests] = useState<IDefferedRequests[]>(
    []
  );
  const [filteredapprovedRequests, setfilteredapprovedRequests] = useState<
    IDefferedRequests[]
  >([]);
  const [filteredNewRequests, setFilteredNewRequests] = useState<
    IDefferedRequests[]
  >([]);
  const [filteredRejectedRequests, setFilteredRejectedRequests] = useState<
    IDefferedRequests[]
  >([]);
  const [isSearchEmpty, setIsSearchEmpty] = useState(false);
  const [requestData, setRequestData] = useState<IDefferedRequests>();
  const [loading, setLoading] = useState(true);
  const [isDefer, setDefer] = useState(false);
  const [reload, setReload] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef(null);
  const toast = useToast();
  const [isOpenAlert, setIsOpen] = useState(false);
  const onCloseAlert = () => setIsOpen(false);
  const [rejectRequest, setRejectRequest] = useState<IDefferedRequests>();
  const openApproveDeferModal = async (request: IDefferedRequests) => {
    setDefer(true);
    setRequestData(request);
    onOpen();
  };
  const reloadData = () => {
    setReload(!reload);
  };

  useEffect(() => {
    DefermentService.getDeferredAdmissionRequests("pending", "100")
      .then((response) => {
        setNewRequests(response.data);
        setLoading(false);
        setFilteredNewRequests(response.data);
      })
      .catch((err) => err);
    DefermentService.getDeferredAdmissionRequests("approved", "100")
      .then((response) => {
        setApprovedRequests(response.data);
        setfilteredapprovedRequests(response.data);
      })
      .catch((err) => err);
    DefermentService.getDeferredAdmissionRequests("rejected", "100")
      .then((response) => {
        setRejectedRequests(response.data);
        setFilteredRejectedRequests(response.data);
      })
      .catch((err) => err);
  }, [reload]);

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();

    if (!searchTerm) {
      setFilteredNewRequests(newRequests);
    } else {
      if (newRequests) {
        const filtered = newRequests.filter((each: any) =>
          each.user.name.toLowerCase().includes(searchTerm)
        );
        setFilteredNewRequests(filtered);

        if (filtered && filtered.length > 0) setIsSearchEmpty(false);
        else setIsSearchEmpty(true);
      }
    }
  };
  const handleSearchChangeTr = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();

    if (!searchTerm) {
      setfilteredapprovedRequests(approvedRequests);
    } else {
      if (approvedRequests) {
        const filtered = approvedRequests.filter((each: any) =>
          each.user.name.toLowerCase().includes(searchTerm)
        );
        setfilteredapprovedRequests(filtered);

        if (filtered && filtered.length > 0) setIsSearchEmpty(false);
        else setIsSearchEmpty(true);
      }
    }
  };
  const handleSearchChangeCr = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();

    if (!searchTerm) {
      setFilteredRejectedRequests(rejectedRequests);
    } else {
      if (rejectedRequests) {
        const filtered = rejectedRequests.filter((each: any) =>
          each.user.name.toLowerCase().includes(searchTerm)
        );
        setFilteredRejectedRequests(filtered);

        if (filtered && filtered.length > 0) setIsSearchEmpty(false);
        else setIsSearchEmpty(true);
      }
    }
  };
  const rejectAlert = (reject: IDefferedRequests) => {
    setIsOpen(true);
    setRejectRequest(reject);
  };

  const rejectDeferAdmission = async () => {
    try {
      const rejectdata: any = {
        defer_admission_id: rejectRequest?.id.toString(),
        new_session_id: rejectRequest?.defer_till_session_id.toString(),
        new_term_id: rejectRequest?.defer_till_term_id.toString(),
        status: "reject",
      };
      const approvedeferRequest = await DefermentService.processDeferRequest(
        rejectdata
      );

      if (approvedeferRequest) {
        toast({
          title: "Reject Defer Request",
          description: `${approvedeferRequest.message}`,
          status: "success",
          duration: 2000,
        });
        reloadData();
        setRejectRequest(undefined);
        onCloseAlert(); // Close the modal here
      }
    } catch (error: any) {
      toast({
        title: "Reject Defer Request",
        description: `${error.response.data.message}`,
        status: "error",
      });
      reloadData();
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Flex
          minHeight={"100vh"}
          height={"auto"}
          boxSizing="border-box"
          maxWidth={"100hw"}
        >
          <Box
            width={["3.5rem", "3.5rem", "3.5rem", "20%"]}
            position="relative"
            top="0"
            left="0"
            zIndex="100"
          >
            <AdminSidebar />
          </Box>

          <Box width="100%">
            <AdminDashboardHeader />
            <Box
              pt="30px"
              px={["20px", "30px"]}
              width={"100%"}
              bg="#F9F8F8"
              height={"auto"}
              minHeight={"95vh"}
              maxHeight={"95vh"}
              overflowX={"scroll"}
              className="scroll-hidden"
            >
              <Flex
                justifyContent="space-between"
                alignItems="center"
                py="26px"
              >
                <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                  Deferred Admissions
                </Box>

                <HStack>
                  <Menu>
                    <MenuButton
                      as={Button}
                      rightIcon={<BsChevronDown />}
                      bg="white"
                      color="#616161"
                      variant={"outline"}
                      size="sm"
                      fontSize={13}
                      width="106px"
                      border="1px solid"
                      borderColor="#9E9E9E"
                    >
                      2022/2023
                    </MenuButton>
                    <MenuList fontSize={12}>
                      <MenuItem>2022/2023</MenuItem>

                      <MenuItem>2021/2022</MenuItem>
                      <MenuItem> 2020/2021</MenuItem>
                      <MenuItem>2019/2020</MenuItem>
                    </MenuList>
                  </Menu>
                </HStack>
              </Flex>
              <Tabs colorScheme="red">
                <TabList
                  py="10px"
                  px={["10px", "10px", "20px", "30px"]}
                  bg="white"
                  justifyContent="space-between"
                  width={"100%"}
                  overflowX={"scroll"}
                  className="scroll-hidden"
                >
                  <Tab>
                    <HStack>
                      <Text
                        fontSize={["14px", "14px", "16px", "18px"]}
                        whiteSpace="nowrap"
                        ml={3}
                        color="#616161"
                        fontWeight="600"
                      >
                        New Requests
                      </Text>
                      <Center
                        bg="#EC3337"
                        width={["20px", "20px", "30px", "32px"]}
                        height={["20px", "20px", "30px", "32px"]}
                        borderRadius="50%"
                      >
                        <Text color="white">{newRequests.length}</Text>
                      </Center>
                    </HStack>
                  </Tab>
                  <Tab>
                    <HStack>
                      <Text
                        fontSize={["14px", "14px", "16px", "18px"]}
                        whiteSpace="nowrap"
                        ml={3}
                        color="#616161"
                        fontWeight="600"
                      >
                        Approved
                      </Text>
                      <Center
                        bg="#EC3337"
                        width={["20px", "20px", "30px", "32px"]}
                        height={["20px", "20px", "30px", "32px"]}
                        borderRadius="50%"
                      >
                        <Text color="white">{approvedRequests.length}</Text>
                      </Center>
                    </HStack>
                  </Tab>
                  <Tab>
                    <HStack>
                      <Text
                        fontSize={["14px", "14px", "16px", "18px"]}
                        whiteSpace="nowrap"
                        ml={3}
                        color="#616161"
                        fontWeight="600"
                      >
                        Rejected
                      </Text>
                      <Center
                        bg="#EC3337"
                        width={["20px", "20px", "30px", "32px"]}
                        height={["20px", "20px", "30px", "32px"]}
                        borderRadius="50%"
                      >
                        <Text color="white">{rejectedRequests.length}</Text>
                      </Center>
                    </HStack>
                  </Tab>
                </TabList>

                <TabPanels>
                  <TabPanel>
                    <Flex py="15px" justifyContent="">
                      <InputGroup
                        color="brand.subtitle"
                        bg="white"
                        width={["90%", "90%", "50%", "30%"]}
                      >
                        <Input
                          height="40px"
                          placeholder="Search new requests"
                          onChange={(e) => handleSearchChange(e)}
                          fontSize={12}
                          size="sm"
                        />

                        <InputRightElement
                          pointerEvents="none"
                          children={<RiSearch2Line color="red" size="0.9rem" />}
                        />
                      </InputGroup>
                    </Flex>
                    <Box width="100%">
                      <TableContainer>
                        <Table variant="simple">
                          <Thead mb="10px" fontSize="14px">
                            <Tr
                              pb="10px"
                              borderBottom="1px solid"
                              borderColor="#D5D5D5"
                            >
                              <Th width="70px">
                                <Checkbox></Checkbox>
                              </Th>
                              <Th textTransform="none">Trainee</Th>
                              <Th textTransform="none">Course</Th>
                              <Th textTransform="none">Date Requested</Th>
                              <Th textTransform="none">Reason For Deferring</Th>
                              <Th textTransform="none">Options</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {filteredNewRequests &&
                              filteredNewRequests.map((eachreq, index) => (
                                <Tr key={index} bg="white">
                                  <Td width="70px">
                                    <Checkbox></Checkbox>
                                  </Td>
                                  <Td>
                                    <HStack spacing="10px">
                                      <Avatar name={"Nil"} size="sm" />

                                      <Text
                                        fontWeight="600"
                                        textTransform="capitalize"
                                        fontSize="16px"
                                        color="#616161"
                                      >
                                        {eachreq.user.name}
                                      </Text>
                                    </HStack>
                                  </Td>
                                  <Td>
                                    {" "}
                                    <Text
                                      fontWeight="600"
                                      textTransform="capitalize"
                                      fontSize="14px"
                                      color="#616161"
                                    >
                                      {eachreq.course_enrollment.course.name.substring(
                                        0,
                                        50
                                      )}
                                    </Text>
                                  </Td>
                                  <Td>
                                    {" "}
                                    <Text
                                      fontWeight="600"
                                      textTransform="capitalize"
                                      fontSize="14px"
                                      color="#616161"
                                    >
                                      {getFullDate(eachreq.application_date)}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Text
                                      fontWeight="600"
                                      textTransform="capitalize"
                                      fontSize="14px"
                                      color="#616161"
                                    >
                                      {eachreq.reason.substring(0, 50)}
                                    </Text>
                                  </Td>

                                  <Td>
                                    <HStack px="16px" spacing="10px">
                                      <IconButton
                                        colorScheme="green"
                                        aria-label="check"
                                        onClick={() => {
                                          openApproveDeferModal(eachreq);
                                        }}
                                        icon={<BsCheckLg />}
                                      />
                                      <IconButton
                                        colorScheme="red"
                                        aria-label="check"
                                        onClick={() => {
                                          rejectAlert(eachreq);
                                        }}
                                        icon={<FaTimes />}
                                      />
                                    </HStack>
                                  </Td>
                                </Tr>
                              ))}
                          </Tbody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </TabPanel>
                  <TabPanel>
                    <Flex py="15px" justifyContent="">
                      <InputGroup
                        color="brand.subtitle"
                        bg="white"
                        width={["90%", "90%", "50%", "30%"]}
                      >
                        <Input
                          height="40px"
                          placeholder="Search trainers"
                          onChange={(e) => handleSearchChangeTr(e)}
                          fontSize={12}
                          size="sm"
                        />

                        <InputRightElement
                          pointerEvents="none"
                          children={<RiSearch2Line color="red" size="0.9rem" />}
                        />
                      </InputGroup>
                    </Flex>
                    <Box width="100%">
                      <TableContainer>
                        <Table variant="simple">
                          <Thead mb="10px" fontSize="14px">
                            <Tr
                              pb="10px"
                              borderBottom="1px solid"
                              borderColor="#D5D5D5"
                            >
                              <Th textTransform="none">Trainee</Th>
                              <Th textTransform="none">Course</Th>
                              <Th textTransform="none">Date Requested</Th>
                              <Th textTransform="none">Reason For Deferring</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {filteredapprovedRequests &&
                              filteredapprovedRequests.map((eachreq, index) => (
                                <Tr key={index} bg="white">
                                  <Td>
                                    <HStack spacing="10px">
                                      <Avatar name={"Nil"} size="sm" />

                                      <Text
                                        fontWeight="600"
                                        textTransform="capitalize"
                                        fontSize="16px"
                                        color="#616161"
                                      >
                                        {eachreq.user.name}
                                      </Text>
                                    </HStack>
                                  </Td>
                                  <Td>
                                    {" "}
                                    <Text
                                      fontWeight="600"
                                      textTransform="capitalize"
                                      fontSize="14px"
                                      color="#616161"
                                    >
                                      {eachreq.course_enrollment.course.name.substring(
                                        0,
                                        50
                                      )}
                                      ....
                                    </Text>
                                  </Td>
                                  <Td>
                                    {" "}
                                    <Text
                                      fontWeight="600"
                                      textTransform="capitalize"
                                      fontSize="14px"
                                      color="#616161"
                                    >
                                      {getFullDate(eachreq.application_date)}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Text
                                      fontWeight="600"
                                      textTransform="capitalize"
                                      fontSize="14px"
                                      color="#616161"
                                    >
                                      {eachreq.reason.substring(0, 60)}
                                    </Text>
                                  </Td>
                                </Tr>
                              ))}
                          </Tbody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </TabPanel>
                  <TabPanel>
                    <Flex py="15px" justifyContent="">
                      <InputGroup
                        color="brand.subtitle"
                        bg="white"
                        width={["90%", "90%", "50%", "30%"]}
                      >
                        <Input
                          height="40px"
                          placeholder="Search for course"
                          onChange={(e) => handleSearchChangeCr(e)}
                          fontSize={12}
                          size="sm"
                        />

                        <InputRightElement
                          pointerEvents="none"
                          children={<RiSearch2Line color="red" size="0.9rem" />}
                        />
                      </InputGroup>
                    </Flex>
                    <Box width="100%">
                      <TableContainer>
                        <Table variant="simple">
                          <Thead mb="10px" fontSize="14px">
                            <Tr
                              pb="10px"
                              borderBottom="1px solid"
                              borderColor="#D5D5D5"
                            >
                              <Th textTransform="none">Trainee</Th>
                              <Th textTransform="none">Course</Th>
                              <Th textTransform="none">Date Requested</Th>
                              <Th textTransform="none">Reason For Deferring</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {filteredRejectedRequests &&
                              filteredRejectedRequests.map((eachreq, index) => (
                                <Tr key={index} bg="white">
                                  <Td>
                                    <HStack spacing="10px">
                                      <Avatar name={"Nil"} size="sm" />

                                      <Text
                                        fontWeight="600"
                                        textTransform="capitalize"
                                        fontSize="16px"
                                        color="#616161"
                                      >
                                        {eachreq.user.name}
                                      </Text>
                                    </HStack>
                                  </Td>
                                  <Td>
                                    {" "}
                                    <Text
                                      fontWeight="600"
                                      textTransform="capitalize"
                                      fontSize="14px"
                                      color="#616161"
                                    >
                                      {eachreq.course_enrollment.course.name.substring(
                                        0,
                                        50
                                      )}
                                      ....
                                    </Text>
                                  </Td>
                                  <Td>
                                    {" "}
                                    <Text
                                      fontWeight="600"
                                      textTransform="capitalize"
                                      fontSize="14px"
                                      color="#616161"
                                    >
                                      {getFullDate(eachreq.application_date)}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Text
                                      fontWeight="600"
                                      textTransform="capitalize"
                                      fontSize="14px"
                                      color="#616161"
                                    >
                                      {eachreq.reason.substring(0, 150)}
                                    </Text>
                                  </Td>
                                </Tr>
                              ))}
                          </Tbody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </Box>
          </Box>
          {isDefer && (
            <Portal>
              {" "}
              <ApproveRejectDeferModal
                isOpen={isOpen}
                onClosed={onClose}
                isDefer={isDefer}
                reload={reloadData}
                data={requestData}
              />{" "}
            </Portal>
          )}
          <Portal>
            <AlertDialog
              isOpen={isOpenAlert}
              leastDestructiveRef={cancelRef}
              onClose={onCloseAlert}
            >
              <AlertDialogOverlay>
                <AlertDialogContent>
                  <AlertDialogHeader fontSize="md" fontWeight="semibold">
                    Reject Defer Admission Request
                  </AlertDialogHeader>

                  <AlertDialogBody fontSize={15}>Are you sure?</AlertDialogBody>

                  <AlertDialogFooter>
                    <Button size={"sm"} ref={cancelRef} onClick={onCloseAlert}>
                      Cancel
                    </Button>
                    <Button
                      size={"sm"}
                      colorScheme="red"
                      onClick={rejectDeferAdmission}
                      ml={3}
                    >
                      Reject
                    </Button>
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialogOverlay>
            </AlertDialog>
          </Portal>
        </Flex>
      )}
    </>
  );
};

export default AdminDeferredAdmission;
